import React from 'react';
import { useTranslation } from 'react-i18next';
import { GenericModalTypes, GenericModalWithIconContent } from '../../shared';
import { AcceptVtoSuccessButton } from './AcceptVtoSuccessButton';
import { Text } from '@amzn/atoz-web/Text';
import { MessageBanner } from '@amzn/atoz-web/MessageBanner';
import { Col } from '@amzn/atoz-web/Col';
import { useAcceptVtoSuccessData } from './utils';
export var AcceptVtoSuccess = function (_a) {
    var close = _a.close, scheduleShift = _a.scheduleShift;
    var t = useTranslation().t;
    var _b = useAcceptVtoSuccessData({ scheduleShift: scheduleShift }), vtoDurationStr = _b.vtoDurationStr, vtoIntervalStr = _b.vtoIntervalStr, bannerText = _b.bannerText;
    return (React.createElement(GenericModalWithIconContent, { dataTestId: "AcceptVtoSuccess", mainText: t('shift_management_features_VtoAcceptedConfirmationModal_vtoAccepted'), onClose: close, buttons: [React.createElement(AcceptVtoSuccessButton, { onClick: close, key: "OK" })], type: GenericModalTypes.success },
        React.createElement(Col, { gridGap: "S200" },
            React.createElement(Text, { dataTestId: "AcceptVtoSuccessApplied" }, t('shift_management_features_VtoAcceptedConfirmationModal_vtoApplied', {
                intervalStr: vtoIntervalStr,
                durationStr: vtoDurationStr
            })),
            !!bannerText && (React.createElement(MessageBanner, { dataTestId: "AcceptVtoSuccessBanner" }, bannerText)))));
};
